import React, { useState } from 'react';
import PaymentCard from '@ui-components/card/form-card';
import configuration from "./fields-config";
import { validateData } from '@utils/validators';
import { paymentCreditCard } from '@services/credit-card';
import { PAYMENT_CARD_STATUS } from '@constants';

const errorInitialState = {
    name: false,
    general: false,
    pan: false,
    cvv: false,
    expiration: false,
    rejected: false
};

const CardFormContainer = ({country, invoiceTransaction, amount, onBack}) => {

    const [fieldsValues, setFieldsValues] = useState({ name: "" });
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState<object>(errorInitialState);
    const [payment, setPayment] = useState<any>(true);

    const onReset = () => {
        setIsLoading(false);
        setErrors(errorInitialState);
        setFieldsValues({ name: '' });
    };

    const handleChange = (fieldsValues) => {
        const errors = validateData(configuration.validators, fieldsValues);
        setErrors(errors);
        setFieldsValues(fieldsValues);
    };

    const validate = () => {
        const errors = validateData(configuration.validators, fieldsValues);

        let hasErrors = false;
        setErrors(errors);

        configuration.fields.forEach((field) => {
            if (errors[field.name])
                hasErrors = true;
        });

        return hasErrors;
    };

    const returnInvoicePage = () => {
        onReset();
        onBack()
    }

    const setRejected = ({status}) => {
        if (status !== PAYMENT_CARD_STATUS.PAID)
            setErrors({ ...errors, rejected: true });
    }

    const handleSubmit = async (smartFieldsToken) => {
        try {
            if (smartFieldsToken) {
                setIsLoading(true);
                const paymentRequest = {
                    id_transaction: invoiceTransaction.id_transaction,
                    cardholder_name: fieldsValues.name,
                    smart_fields_token: smartFieldsToken,
                    country
                };
                const payment = await paymentCreditCard(paymentRequest);
                
                setPayment(payment);
                setRejected(payment);
                setIsLoading(false);
            }
        } catch (error) {
            setErrors({ ...errors, rejected: true });
            setIsLoading(false);
            throw error;
        }
    };

    return (
        <PaymentCard
            hideIcon={true}
            showCvvHelper={true}
            errors={errors}
            validate={validate}
            onSubmit={handleSubmit}
            onChange={handleChange}
            isLoading={isLoading}
            setLoading={setIsLoading}
            fieldsConfig={configuration}
            fieldsValues={fieldsValues}
            returnInvoicePage={returnInvoicePage}
            onReset={onReset}
            success={payment && payment.status === PAYMENT_CARD_STATUS.PAID}
            amount={amount}
            country={country}
        />
    );
}

export default CardFormContainer;